import React, { useState, useEffect } from "react";

import "./index.css";
import "./style.css";

import Hero from "./components/Hero";
import About from "./components/About";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Skills from "./components/Skills";
import Contact from "./components/Contact";
import Project from "./components/Project";
import Services from "./components/Services";
import Testismonial from "./components/Testismonial";

const App = () => {
  const [mobile, setMobile] = useState(false);
  const handleResize = () => {
    if (innerWidth <= 640) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  };

  useEffect(() => {
    if (typeof window != undefined) {
      addEventListener("resize", handleResize);
    }

    return () => {
      removeEventListener("resize", handleResize);
    };
  }, []);
 
  const handleToggle = () => {
    setMobile((prevMobile) => !prevMobile);
  };

  return (
    <div className="bg-black bg-gradient-to-tl from-zinc-900 via-zinc-400/10 to-zinc-900 text-zinc-400">
      <Navbar toggle={handleToggle} mobile={mobile} />
      <Hero />
      <About />
      <Project />
      <Services />
      <Testismonial />
      <Contact />
      <Skills />
      <Footer />
    </div>
  );
};

export default App;
